import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteUnitFirmware = async (firmwareId: string): Promise<boolean> =>
  axios.delete(`/management/unitfirmware/removeunitfirmware?firmwareId=${firmwareId}`).then((res) => res?.data?.result)

type Props = {
  firmwareId: string
}

export const useManagementDeleteUnitFirmware = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteUnitFirmware'],
    mutationFn: ({ firmwareId }: Props) => deleteUnitFirmware(firmwareId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted device firmware.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete device firmware, please try again.')
      }
    },
    throwOnError: false
  })
